import { type SimpleSelectOption } from '@workwave-tidal/core/components'
import { type RecurrenceWhen } from '../../../../types'
import { createRecurrenceWhenId } from './createRecurrenceWhenId'

export function createDaysOfWeekOptions(
  weekStartsOn: uui.domain.WeeklyValidSelection,
  formatRecurrenceWhenLabel: (recurrenceWhen: RecurrenceWhen) => string,
): SimpleSelectOption<string>[] {
  // Ex => startOfWeek = 6 | [0, 1, 2, 3, 4, 5, 6] => [6, 0, 1, 2, 3, 4, 5]
  const shiftedDaysOfWeek = getDaysOfWeek()
    .slice(weekStartsOn)
    .concat(getDaysOfWeek().splice(0, weekStartsOn))

  // Create array of objects with day index as key and day name as value
  return shiftedDaysOfWeek.map<SimpleSelectOption<string>>(weekday => {
    const recurrenceWhen: RecurrenceWhen = { type: 'WEEKLY', weekday }
    return {
      value: createRecurrenceWhenId(recurrenceWhen),
      label: formatRecurrenceWhenLabel(recurrenceWhen),
    }
  })
}

const getDaysOfWeek = () => [0, 1, 2, 3, 4, 5, 6]
